/*	-----------------------------------------------------------------------------------------------
 recruit
 revruit/interview
 --------------------------------------------------------------------------------------------------- */
$(document).ready(function () {
    const widthDevice = document.documentElement.clientWidth;
    /*Task: DSG-15235*/
    var scroll_start = 0;
    /* DSG-14829*/
    const height = $(".hr-description").height();
    var width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
    /* END DSG-14829*/

    $('.interview-job-openings__detail--mid').show();
    $('.js-fade-ul').show();
    $('.interview-job-openings__detail--new').hide();
    $('.list-c').hide();


    $('.list-c').click(function () {
        $('.list-a').removeClass('list-current');
        $('.list-b').addClass('list-current');
        $('.interview-job-openings__detail--mid, .js-fade-ul').fadeOut(500);
        $('.interview-job-openings__detail--new').fadeIn(500);
    });
    /* ---------- recruit02 start --------- */

    $(function () {
        $(window).scroll(function () {
            $('.js_window_in_one').each(function () {
                var obj_t_pos = $(this).offset().top;
                var scr_count = $(document).scrollTop() + (window.innerHeight / 1);
                if (scr_count > obj_t_pos) {
                    $(this).addClass('_show');
                }
            });
        });
    });
    // Change background and menu color in top page recruit
    if ($('#recruitment-bg-top').length > 0) {
        //window.addEventListener('load', () => {
        //    $(".recruit-page").addClass('recruit02_background_menu');
        //    $('.header-recruitment .recruit-page .header__right .header__nav-list li span').addClass('recruit02_color_menu');
        //    $('.header-recruitment .header__inner .header__right .header__nav-list li').addClass('recruit02_with_border');
        //    $('.header-recruitment .header__left').addClass('recruit02_remove_border_menu');
        //    $('.hamburger__btn span').addClass('border_menu_icon_white');
        //    $('.header__logo a img').attr("src", "//cdn.shopify.com/s/files/1/0789/3355/7552/files/header-recruitment-recruit-logo-white.png");
        //});
        window.addEventListener('scroll', function () {
            var background_top_recruit_height = $('.zoom-in-img').height();
            const verticalScrollPx = window.scrollY;
            if (verticalScrollPx < background_top_recruit_height) {
                $(".recruit-page").addClass('recruit02_background_menu');
                $('.header-recruitment .recruit-page .header__right .header__nav-list li span').addClass('recruit02_color_menu');
                $('.header-recruitment .header__inner .header__right .header__nav-list li').addClass('recruit02_with_border');
                $('.header-recruitment .header__left').addClass('recruit02_remove_border_menu');
                $('.hamburger__btn span').addClass('border_menu_icon_white');

                $('.header__logo a img').attr("src", "//cdn.shopify.com/s/files/1/0789/3355/7552/files/header-recruitment-recruit-logo-white.png");
            } else {
                $(".recruit-page").removeClass('recruit02_background_menu');
                $('.header-recruitment .recruit-page .header__right .header__nav-list li span').removeClass('recruit02_color_menu');
                $('.header-recruitment .header__inner .header__right .header__nav-list li').removeClass('recruit02_with_border');
                $('.hamburger__btn span').removeClass('border_menu_icon_white');

                $('.header__logo a img').attr("src", "//cdn.shopify.com/s/files/1/0789/3355/7552/files/header-recruitment-recruit-logo.png");
            }
            $('.header-recruitment.active .header__logo a img').attr("src", "//cdn.shopify.com/s/files/1/0789/3355/7552/files/header-recruitment-recruit-logo-white-all.png");
        });
    }
    $('.slick-recruit02-top').slick({
        autoplay: false,
        autoplaySpeed: 3000,
        speed: 500,
        centerMode: true,
        centerPadding: '0px',
        variableWidth: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        initialSlide: 1,
        responsive: [
            {
                breakpoint: 1680,
                settings: {
                    initialSlide: 0,
                    centerMode: false,
                    centerPadding: '60px',
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 1366,
                settings: {
                    initialSlide: 0,
                    centerPadding: '60px',
                    centerMode: false,
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    initialSlide: 0,
                    centerMode: false,
                    centerPadding: '0px',
                    slidesToShow: 1
                }
            }
        ],
    });
    /* ---------- recruit02 end --------- */

    /* ---------- People start --------- */
    $('.slick-recruit02-people').slick({
        autoplay: false,
        autoplaySpeed: 3000,
        variableWidth: true,
        speed: 500,
        centerMode: false,
        centerPadding: '60px',
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        initialSlide: 0,
        responsive: [
            {
                breakpoint: 1680,
                settings: {
                    initialSlide: 0,
                    centerMode: false,
                    centerPadding: '60px',
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 1366,
                settings: {
                    initialSlide: 0,
                    centerPadding: '60px',
                    centerMode: false,
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    initialSlide: 0,
                    centerMode: false,
                    centerPadding: '30px',
                    slidesToShow: 1
                }
            }
        ],
    });
    /* ---------- People end --------- */

    /* ---------- slick slider autoplay inview start --------- */
    var slickRecruit02Element = $('.slick-recruit02-top');
    var slickRecruit02PeopleElement = $('.slick-recruit02-people');
    $(window).on('scroll', function () {
        checkSliderPlayInView();
    });
    function checkSliderPlayInView() {
        if (slickRecruit02Element.hasClass('_show')) {
            $('.slick-recruit02-top').slick('slickPlay');
        }
        if (slickRecruit02PeopleElement.hasClass('_show')) {
            $('.slick-recruit02-people').slick('slickPlay');
        }
    }
    /* ---------- slick slider autoplay inview end --------- */

    /* Example element home */
    //$("ul.header__nav-list > li:last-child span").html("ENTRY");

    var startChange = $('#recruitment-bg-top');
    var offset = startChange.offset();
    if (startChange.length) {
        $(document).scroll(function () {
            scroll_start = $(this).scrollTop();
            if (scroll_start > offset.top) {
                $(".recruit-homepage").addClass('recruit-page');
                $("img.recruit-homepage").attr("src", "//cdn.shopify.com/s/files/1/0789/3355/7552/files/header-recruitment-recruit-logo.png");
                /* Red hamburger*/
                $(".js-hamburger span").removeClass('white-color');
            } else {
                $(".recruit-homepage").removeClass('recruit-page');
                $("img.recruit-homepage").attr("src", "//cdn.shopify.com/s/files/1/0789/3355/7552/files/header-recruitment-recruit-logo-white.png");
                /* White hamburger*/
                $(".js-hamburger span").addClass('white-color');
            }
        });
    }
    /*End Task: DSG-15235*/

    $('.slick-recruit-office').slick({
        centerMode: true,
        centerPadding: '0px',
        slidesToShow: 5,
        slidesToScroll: 1,
        arrows: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    centerMode: true,
                    centerPadding: '0px',
                    slidesToShow: 1
                }
            }
        ],
    });

    $('.slick-recruit-office--kimei').slick({
        centerMode: true,
        centerPadding: '0px',
        slidesToShow: 5,
        slidesToScroll: 1,
        arrows: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    centerMode: true,
                    centerPadding: '0px',
                    slidesToShow: 1
                }
            }
        ],
    });
});

function mousedragscrollable(element) {
    let target;
    const elms = document.querySelectorAll(element);
    for (let i = 0; i < elms.length; i++) {
        elms[i].addEventListener('mousedown', function (evt) {
            evt.preventDefault();
            target = elms[i];
            target.dataset.down = 'true';
            target.dataset.move = 'false';
            target.dataset.x = evt.clientX;
            target.dataset.y = evt.clientY;
            target.dataset.scrollleft = target.scrollLeft;
            target.dataset.scrolltop = target.scrollTop;
            evt.stopPropagation();
        });
        elms[i].addEventListener('click', function (evt) {
            if (elms[i].detaset != null && elms[i].detaset.move == 'true') evt.stopPropagation();
        });
    }
    document.addEventListener('mousemove', function (evt) {
        if (target != null && target.dataset.down == 'true') {
            evt.preventDefault();
            let move_x = parseInt(target.dataset.x) - evt.clientX;
            let move_y = parseInt(target.dataset.y) - evt.clientY;
            if (move_x !== 0 || move_y !== 0) {
                target.dataset.move = 'true';
            } else {
                return;
            }
            target.scrollLeft = parseInt(target.dataset.scrollleft) + move_x;
            target.scrollTop = parseInt(target.dataset.scrolltop) + move_y;
            evt.stopPropagation();
        }
    });
    document.addEventListener('mouseup', function (evt) {
        if (target != null && target.dataset.down == 'true') {
            target.dataset.down = 'false';
            evt.stopPropagation();
        }
    });
}

window.addEventListener('DOMContentLoaded', function () {
    mousedragscrollable('.x-drag-scroll');
});

/*	-----------------------------------------------------------------------------------------------
 recruit
 recruit/gallery
 --------------------------------------------------------------------------------------------------- */
$(document).ready(function () {
    $('.slick-recruit-gallery-block-ltr').slick({
        speed: 1500,
        autoplay: true,
        centerMode: true,
        centerPadding: '0px',
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: true,
        autoplaySpeed: 5000,
        initialSlide: 0,
        responsive: [
            {
                breakpoint: 1025,
                settings: {
                    centerMode: true,
                    centerPadding: '0px',
                    slidesToShow: 1,
                    initialSlide: -1
                }
            }
        ],
    });

    $('.slick-recruit-gallery-block-rtl').slick({
        speed: 1500,
        autoplay: true,
        centerMode: true,
        centerPadding: '0px',
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: true,
        autoplaySpeed: 5000,
        rtl: true,
        initialSlide: 0,
        responsive: [
            {
                breakpoint: 1025,
                settings: {
                    centerMode: true,
                    centerPadding: '0px',
                    slidesToShow: 1
                }
            }
        ],
    });

    // Count number
    function launchCountUp(o) {
        var e, t, a = o.attr("data-num"),
            r = o.text();
        o.hasClass("count-slow") ? t = 200 : o.hasClass("count-fast") && (t = 50), e = setInterval(function () {
            var t = r++,
                n = ("0" + t).slice(-2);
            10 < a && t < 10 ? o.text(n) : o.text(t), t == a && clearInterval(e)
        }, t)
    }
    function detectCountElement(t) {
        $.each(t, function (t, n) {
            var o, e, a = $(n);
            a.attr("data-isLaunched") || (o = (e = $(window)).scrollTop(), n = e.innerHeight(), o < (e = a.offset()).top && e.top < o + n && (launchCountUp(a), a.attr("data-isLaunched", !0)))
        })
    }
    $(function () {
        var t = !1,
            n = $(".count");
        $(window).on("load", function () {
            setTimeout(function () {
                t || (t = !0, detectCountElement(n))
            }, 750)
        }), setTimeout(function () {
            t || (t = !0, detectCountElement(n))
        }, 3350), $(window).scroll(detectCountElement.bind(window, n))
    });
});
